import React, { useState } from 'react';
import { partial } from '../../../util/translation/translation';
import useConfig from '../../../util/useConfig';
import exampleCurrency from '../../user_tiers/components/exampleCurrency';

// Example fundraiser: raised so far of the target, and supporters
const RAISED = 32400;
const TARGET = 50000;
const AMOUNTS = [5, 10, 20];

const money = (amount, currency) =>
  `${amount.toLocaleString('sv-SE')} ${currency}`;

/**
 * A fundraiser as supporters see it (website and app): the goal with its
 * progress bar, an amount per goal to pick, and the top supporters.
 * Example values; the amounts can be clicked.
 */
const ClubheartFundraiserPreview = () => {
  const s = partial('shared');
  const currency = exampleCurrency(useConfig());
  const [amount, setAmount] = useState(10);
  const percent = Math.round((RAISED / TARGET) * 100);

  return (
    <div className="tier-phone heart-preview">
      <div className="heart-preview__head">
        <span aria-hidden>‹</span>
        {s('heartPreviewTitle')}
      </div>
      <div className="heart-preview__body">
        <div className="heart-preview__goal">
          <strong>{s('heartPreviewCause')}</strong>
          <div className="heart-preview__bar" aria-hidden>
            <span style={{ width: `${percent}%` }} />
          </div>
          <span className="heart-preview__numbers">
            <b>{money(RAISED, currency)}</b>{' '}
            {s('heartPreviewOf', { target: money(TARGET, currency) })}
            <span>{s('heartPreviewSupporters', { count: 128 })}</span>
          </span>
        </div>

        <div className="heart-preview__pick">
          <span>{s('heartPreviewPerGoal')}</span>
          <div className="heart-preview__amounts">
            {AMOUNTS.map((value) => (
              <button
                key={value}
                type="button"
                className={`heart-preview__amount${
                  amount === value ? ' heart-preview__amount--on' : ''
                }`}
                aria-pressed={amount === value}
                onClick={() => setAmount(value)}
              >
                {money(value, currency)}
              </button>
            ))}
          </div>
          <span className="heart-preview__cap">
            {s('heartPreviewCap', { amount: money(amount * 5, currency) })}
          </span>
        </div>

        <span className="heart-preview__support" aria-hidden>
          {s('heartPreviewSupport', { amount: money(amount, currency) })}
        </span>

        <div className="tier-phone__panel">
          <h4>{s('heartPreviewTop')}</h4>
          <ol className="heart-preview__top" aria-hidden>
            <li>
              <span>Andersson Bygg AB</span>
              <b>{money(50, currency)}</b>
            </li>
            <li>
              <span>Lisa J.</span>
              <b>{money(20, currency)}</b>
            </li>
            <li>
              <span>{s('heartPreviewAnonymous')}</span>
              <b>{money(10, currency)}</b>
            </li>
          </ol>
        </div>
      </div>
    </div>
  );
};

export default ClubheartFundraiserPreview;
